import createModel, { prop } from './lib/create_model';

export const RuleScore = createModel({
  modelName: 'RuleScore',

  properties: {
    id: prop(String).isRequired,
    name: prop(String).isRequired,
    revisionId: prop(Number).isRequired,
    value: prop(Number).isRequired,
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export default RuleScore;
